import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const Category = iotsUtils.fromList(constants.notification.categories);
